export const TAB_IDS = {
  BILLING_INFORMATION: 'billingInformation',
  DOCUMENTS: 'documents',
  PAYMENT: 'payment',
} as const;
